import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch } from "react-router-dom";
import './index.css';
import reportWebVitals from './reportWebVitals';
// Import Pages for Router
import App from './App';
import About from './pages/about';
import CommandsList from './pages/commandsList';
import Privacy from './pages/privacyPolicy';
import Terms from './pages/termsOfService';
import callback from './pages/callback';
import discordLogin from './pages/discordLogin'
import Graph from './pages/graph'
import AccountDeleted from './pages/accountDeleted'

// Routers: https://www.freecodecamp.org/news/react-router-in-5-minutes/

ReactDOM.render(
  //<React.StrictMode>
  //  <App />
  //</React.StrictMode>,
  <BrowserRouter>
    <Switch>
      <Route exact path="/">
        <App />
      </Route>
      <Route path="/about" component={About} />
      <Route path="/commandsList" component={CommandsList} />
      <Route path="/privacyPolicy" component={Privacy} />
      <Route path="/termsOfService" component={Terms} />
      <Route path="/callback" component={callback} />
      <Route path="/discordLogin" component={discordLogin} />
      <Route path="/graph" component={Graph} />
      <Route path="/accountDeleted" component={AccountDeleted} />
    </Switch>
  </BrowserRouter>,

  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
